import styled from 'styled-components';

export const BuildingProjectPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const TextBlock = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ImageBlock = styled.div`
  display: flex;
  justify-content: center;
`;

export const FloodGalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FloodCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.9rem;
`;

export const FloodCaption = styled.div`
  font-weight: 600;
  margin-top: 8px;
`;

export const FloodDescription = styled.div`
  font-size: 0.85rem;
`;

export const StatusRow = styled.div`
  font-size: 0.95rem;
`;

export const ProgressBarWrapper = styled.div`
  margin-top: 8px;
  background-color: #f0f0f0;
  border-radius: 999px;
  overflow: hidden;
  height: 24px;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  background-color: #1976D2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 600;
`;
